/**
 * CEP Command shell theme tokens (CEP-001): green and white, simple.
 * Feminine accents (pink / purple / rose / lavender) are for stages, charts and badges only.
 */
export const VIP = {
  bg: "#FFFFFF",
  bgElevated: "#F7F9F6",
  grid: "rgba(30,77,43,0.06)",
  silver: "#5B6660",
  silverDim: "#5B6660",
  white: "#FFFFFF",
  body: "#1A1A19",
  muted: "#5B6660",
  border: "#D9E2DC",
  borderBright: "#D9E2DC",
  tint: "#E6F0E9",
  /** Pills */
  pill: "#1E4D2B",
  pillText: "#FFFFFF",
  /** Cards */
  card: "#1E4D2B",
  cardText: "#FFFFFF",
  /** Titles */
  titleRed: "#F43F5E",
  titleBlue: "#1E4D2B",
  danger: "#B91C1C",
  ok: "#16A34A",
  font: "'Montserrat', 'Barlow', system-ui, sans-serif",
} as const;

/** Human-facing name: never show an openId / user_xxx glitch, and never a hardcoded person. */
export function vipDisplayName(user: {
  name?: string | null;
  openId?: string | null;
  email?: string | null;
  role?: string | null;
} | null | undefined): string {
  if (!user) return "Operator";
  const raw = (user.name || "").trim();
  const openId = (user.openId || "").trim();
  const looksLikeId =
    !raw ||
    raw === openId ||
    /^user[_-]?\d/i.test(raw) ||
    /^user_[a-z0-9]+$/i.test(raw) ||
    (/^[a-f0-9-]{20,}$/i.test(raw) && !raw.includes(" ")) ||
    (raw.length > 28 && !/\s/.test(raw));

  if (!looksLikeId) return raw;

  if (user.role === "admin") return "Owner";
  return "Member";
}
